'use client'

import React, { useEffect } from 'react'

/**
 * Unsichtbares ALTCHA-Widget. Ab altcha v3 heisst das Attribut `challenge`
 * (`challengeurl` waere das v2-Attribut und wuerde still ignoriert).
 */
export const AltchaWidget: React.FC = () => {
  useEffect(() => {
    void import('altcha')
  }, [])

  return React.createElement('altcha-widget', {
    challenge: '/api/altcha',
    auto: 'onload',
    style: { display: 'none' },
  })
}
